import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sid) { navigate("/"); return; }
      try {
        const u = await api.processSession(sid);
        setUser(u);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: u } });
      } catch {
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-pbs-grey gap-3">
      <Loader2 className="animate-spin text-pbs-purple" size={32} />
      <p className="font-semibold">Signing you in…</p>
    </div>
  );
}
